import { Container, makeStyles } from "@material-ui/core";
import { ShaDowBox } from "./ShadowBox";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
    padding: `${theme.spacing(4.5)}px ${theme.spacing(5)}px`,
    width: (props) => props.width,
  },
}));

export const ModalBox = ({ children, maxWidth, width }) => {
  const classes = useStyles({ width: width || 600 });

  return (
    <ShaDowBox>
      <Container maxWidth={maxWidth || "sm"} className={classes.root}>
        {children}
      </Container>
    </ShaDowBox>
  );
};
